require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { store } from './Store';
import { createGtm } from '@gtm-support/vue-gtm';
import VueCreditCardValidation from 'vue-credit-card-validation';


const gtm = createGtm({
    id: process.env.MIX_GOOGLE_TAG_MANAGER_ID,
    enabled: process.env.MIX_APP_ENV === 'production' ? true : false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: process.env.MIX_APP_ENV === 'production' ? false : true, // Whether or not display console logs debugs (optional)
    loadScript: process.env.MIX_APP_ENV === 'production' ? true : false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
});



const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin, Bus }) {
        const acadiaApp = createApp({ render: () => h(app, props) });

        const files = require.context('./Global/', true, /\.vue$/i);

        files.keys().map((key) => acadiaApp.component(key.split('/').pop().split('.')[0], files(key).default));

        return acadiaApp
            .use(plugin)
            .use(store)
            .use(gtm)
            .use(VueCreditCardValidation)
            .mixin({ methods: { route } })
            .mixin(require('./mixins'))
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });
